




import {Component, Prop, Vue} from 'vue-property-decorator'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'
import {Role} from '@/enums/Role'

@Component({
  components: {RenderLabelValue},
})
export default class RenderRole extends Vue {
  @Prop({type: String, required: true}) role!: Role

  get translatedRole() {
    return this.$t(`enums.Role.${this.role}`)
  }

  get roleColor() {
    if (this.role === Role.RESPONSAVEL) {
      return 'default'
    }
    if (this.role === Role.RESPONSAVEL_CHILD) {
      return 'green-dark'
    }
    if (this.role === Role.RESPONSAVEL_VIEWER) {
      return 'orange-yellow'
    }
    if (this.role === Role.VIEWER) {
      return 'orange-yellow'
    }
    if (this.role === Role.ASSOCIATE) {
      return 'green-dark'
    }
    if (this.role === Role.SAC) {
      return 'orange'
    }
    if (this.role === Role.GUEST) {
      return 'contrast default'
    }
    if (this.role === Role.RASTREAMENTO) {
      return 'success'
    }
    return 'default'
  }
}
